import React from 'react';
import { motion } from 'framer-motion';
import { Timer, ArrowRight, Check } from 'lucide-react';
export function Offer() {
  return <section id="oferta" className="py-24 px-4 sm:px-6 lg:px-8 relative bg-cream" data-id="element-133">
      <div className="dashed-divider absolute top-0 left-0" data-id="element-134"></div>

      <div className="max-w-4xl mx-auto" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-white rounded-[2.5rem] shadow-2xl p-8 md:p-12 border-2 border-caramel/20 relative overflow-hidden" data-id="element-136">
          {/* Decorative background */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-rose-light/20 rounded-full blur-3xl -translate-y-3/4 translate-x-3/4 pointer-events-none" data-id="element-137"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-caramel-light/15 rounded-full blur-3xl translate-y-3/4 -translate-x-3/4 pointer-events-none" data-id="element-138"></div>

          <div className="relative z-10 text-center" data-id="element-139">
            <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-4 py-2 rounded-full font-bold text-sm mb-8 animate-pulse" data-id="element-140">
              <Timer className="w-4 h-4" data-id="element-141" />
              OFERTA DE LANZAMIENTO
            </div>

            <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-espresso mb-6 leading-[1.15] pb-2" data-id="element-142">
              Empieza tu negocio dulce hoy
            </h2>

            <div className="flex flex-col items-center justify-center mb-8" data-id="element-143">
              <span className="text-2xl text-espresso-light/60 line-through font-medium mb-2" data-id="element-144">
                Precio Real: $14.00 USD
              </span>
              <div className="flex items-start justify-center gap-1" data-id="element-145">
                <span className="text-3xl font-bold text-caramel mt-2" data-id="element-146">$</span>
                <span className="text-7xl md:text-8xl font-bold text-caramel tracking-tighter" data-id="element-147">
                  6.36
                </span>
                <span className="text-xl font-bold text-caramel mt-auto mb-3" data-id="element-148">
                  USD
                </span>
              </div>
            </div>

            {/* Scarcity Bar */}
            <div className="max-w-md mx-auto mb-10" data-id="element-149">
              <div className="flex justify-between text-sm font-medium text-espresso-light mb-2" data-id="element-150">
                <span data-id="element-151">Unidades reclamadas</span>
                <span className="text-caramel font-bold" data-id="element-152">847 / 1,000</span>
              </div>
              <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden" data-id="element-153">
                <motion.div initial={{
                width: 0
              }} whileInView={{
                width: '84.7%'
              }} transition={{
                duration: 1.5,
                ease: 'easeOut'
              }} className="h-full bg-caramel rounded-full relative" data-id="element-154">
                  <div className="absolute inset-0 bg-white/20 w-full h-full animate-[shimmer_2s_infinite]" data-id="element-155"></div>
                </motion.div>
              </div>
              <p className="text-sm text-red-600 font-medium mt-3" data-id="element-156">
                Oferta limitada a las primeras 1,000 unidades para validar
                nuestro lanzamiento.
              </p>
            </div>

            <div className="max-w-md mx-auto space-y-4 mb-10 text-left" data-id="element-157">
              {['Manual completo en PDF (Descarga inmediata)', 'Recetas exactas y probadas', 'Guía de costos y precios', 'Acceso de por vida'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-158">
                  <div className="w-6 h-6 rounded-full bg-green-100 flex items-center justify-center shrink-0" data-id="element-159">
                    <Check className="w-4 h-4 text-green-600" data-id="element-160" />
                  </div>
                  <span className="text-espresso font-medium" data-id="element-161">{item}</span>
                </div>)}
            </div>

            <a id="cta-final" href="https://noveliahub.com/cart/44208175841316:1" className="group relative inline-flex items-center justify-center gap-2 w-full md:w-auto px-10 py-5 bg-caramel text-white font-bold text-xl rounded-2xl overflow-hidden transition-all hover:bg-caramel-dark hover:shadow-glow hover:-translate-y-1 scroll-mt-24" data-id="element-162">
              <span className="absolute inset-0 w-full h-full bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-163"></span>
              <span className="relative" data-id="element-164">
                SÍ, QUIERO EMPEZAR MI NEGOCIO DULCE POR $6.36
              </span>
              <ArrowRight className="relative w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-165" />
            </a>

            <p className="mt-4 text-sm text-espresso-light font-medium" data-id="element-166">
              Acceso inmediato tras el pago. Envío digital a todo el mundo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}